import aboutIllustration from "../../../../resources/images/about_illustration.png";
import { Box, SxProps, Theme, Grid } from "@mui/material";

export const About = () => {
  return (
    <Box sx={sx} className="About">
      <Grid container className="About-Title">
        <span className="About-Title-Head">A</span>BOUT
      </Grid>
      <Grid container className="About-SubTitle">
        私たちについて
      </Grid>
      <Box className="About-Illustration" component="img" alt="イラスト" src={aboutIllustration} />
      <Box className="About-Description">
        私たちは、<span className="About-Description-Strong">「技術が好き」「開発を楽しみたい」</span>
        という情熱を持つエンジニアが集まった、
        <br className="About-Description-PcBr" />
        コミュニティのような組織です。
        <br className="About-Description-PcBr" />
        メンバーは現場経験豊富なハイレベルなエンジニアばかり。
        <br className="About-Description-PcBr" />
        好きだからこそ常に学び、深く掘り下げ、自主的にスキルを磨き続けており、
        <br className="About-Description-PcBr" />
        その積み重ねが<span className="About-Description-Strong">圧倒的な技術力と実践力</span>に直結しています。
        <br className="About-Description-PcBr" />
        <br className="About-Description-PcBr" />
        社内には特定技術に精通したスペシャリストも多く、
        <br className="About-Description-PcBr" />
        互いに知識を共有し合いながら、チーム全体でスキルを底上げする文化があります。
        <br className="About-Description-PcBr" />
        与えられたタスクをこなすだけでなく、
        構造的な改善提案やアーキテクチャ設計にも強く、
        <br className="About-Description-PcBr" />
        <span className="About-Description-Strong">自律的に価値を生み出せる人材</span>が多数在籍しています。
        <br className="About-Description-PcBr" />
        <br className="About-Description-PcBr" />
        私たちの開発現場では、「面白い」「挑戦したい」という気持ちが原動力。
        <br className="About-Description-PcBr" />
        だからこそ、スピードと品質を両立したものづくりが可能です。
        <br className="About-Description-PcBr" />
        <span className="About-Description-Strong">技術が好きだからこそ、高い成果を出せる。</span>
        <br className="About-Description-PcBr" />
        それが、私たちの強さであり誇りです。
      </Box>
    </Box>
  );
};

const sx: SxProps<Theme> = (theme) => ({
  "&.About": {
    width: "100%",
    background: "rgba(34, 161, 185, 0.1)",
    padding: "60px 0 92px",
  },
  ".About-Title": {
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Avenir Next",
    fontWeight: 500,
    fontSize: {
      md: "64px",
      xs: "40px",
    },
    lineHeight: "88px",
    letterSpacing: "0.15em",
  },
  ".About-Title-Head": {
    color: "#22A1B9",
    fontWeight: 700,
  },
  ".About-SubTitle": {
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 700,
    fontSize: {
      md: "16px",
      xs: "14px",
    },
    lineHeight: {
      md: "24x",
      xs: "20px",
    },
    letterSpacing: "1px",
  },
  ".About-Illustration": {
    marginTop: "21px",
    width: "100%",
  },
  ".About-Description": {
    width: {
      md: "auto",
      xs: "332px",
    },
    margin: "21px auto 0",
    textAlign: "center",
    fontSize: {
      md: "18px",
      xs: "16px",
    },
    fontWeight: 400,
    lineHeight: "35px",
  },
  ".About-Description-PcBr": {
    display: {
      md: "block",
      xs: "none",
    },
  },
  ".About-Description-Strong": {
    color: "#22A1B9",
    fontWeight: 700,
  },
});
